import { types } from "../../Actions/types";

const initialState = {
  jointlist: [],
  error: null,
  jointSingle: "",
  popupmodel: "",
};

const Joint = (state = initialState, action) => {
  let { type, payload, error } = action;
  if (payload && payload.error !== null) {
    error = payload.error;
  }

  switch (type) {
    case types.JOINT_LIST:
      return {
        ...state,
        jointlist: payload,
        error,
      };
    case types.JOINT_SINGLE:
      return {
        ...state,
        jointSingle: payload,
        error,
      };
    case types.JOINT_FORM_MODEL:
      return {
        ...state,
        popupmodel: payload,
      };

    default:
      return state;
  }
};

export default Joint;
